import React, { Component } from 'react';
import '../../node_modules/react-vis/dist/style.css';
import {XYPlot, LineSeries } from 'react-vis';

class ChartLine extends Component { 
  render(data) {
    return (
      <XYPlot height={200} width={150} margin={{left: 10, top: 20, bottom: 10, right: 10}} dontCheckIfEmpty={true}>
        <LineSeries data={data} color={"#152046"} />
      </XYPlot>
    );
  }
}

export default ChartLine